export var PAUSE_REASON_CODES = {
    profile: [
        { value: 'HOSPITALIZED', label: 'Hospitalized' },
        { value: 'MEMBER_REQUESTED', label: 'Member Requested' },
        { value: 'TRAVELING', label: 'Traveling' },
        { value: 'OTHER', label: 'Other' },
    ],
    device: [
        { value: 'DEVICE_TEMPORARILY_NOT_IN_USE', label: 'Device Temporarily Not In Use' },
        { value: 'DEVICE_LOST', label: 'Device Lost' },
        { value: 'DEVICE_DAMAGED', label: 'Device Damaged' },
        { value: 'DEVICE_REPLACEMENT_PENDING', label: 'Device Replacement Pending' },
        { value: 'OTHER', label: 'Other' },
    ],
    notification: [
        { value: 'MEMBER_REQUESTED', label: 'Member Requested' },
        { value: 'FALSE_ALERTS', label: 'False Alerts' },
        { value: 'DEVICE_NOT_WORN', label: 'Device Not Worn' },
        { value: 'TEMPORARY_SUSPENSION', label: 'Temporary Suspension' },
        { value: 'HOSPITALIZED', label: 'Hospitalized' },
        { value: 'VACATION', label: 'Vacation' },
        { value: 'OTHER', label: 'Other' },
    ],
};
export var derivePauseStatus = function (profile, device, notification) { return ({
    profile: profile,
    device: profile || device,
    notification: profile || device || notification,
}); };
export var PAUSE_REASON_LABELS = {
    HOSPITALIZED: 'Hospitalized',
    VACATION: 'Vacation',
    TEMP_UNAVAILABLE: 'Temporarily Unavailable',
    REHABILITATION: 'Rehabilitation',
    MEDICAL_LEAVE: 'Medical Leave',
    SENIOR_REQUESTED: 'Senior Requested',
    CARE_TEAM_REQUESTED: 'Care Team Requested',
    TECHNICAL_ISSUE: 'Technical Issue',
    TRAVELING: 'Traveling',
    DEVICE_NOT_IN_USE: 'Device Not In Use',
    DEVICE_LOST: 'Device Lost',
    DEVICE_DAMAGED: 'Device Damaged',
    DEVICE_REPLACEMENT_PENDING: 'Device Replacement Pending',
    DEVICE_RETURNED: 'Device Returned',
    MEMBER_NOT_USING_DEVICE: 'Member Not Using Device',
    CONNECTIVITY_ISSUE: 'Connectivity Issue',
    BATTERY_ISSUE: 'Battery Issue',
    DEVICE_MAINTENANCE: 'Device Maintenance',
    FALSE_ALERTS: 'False Alerts',
    DEVICE_NOT_WORN: 'Device Not Worn',
    TEMPORARY_SUSPENSION: 'Temporary Suspension',
    OTHER: 'Other',
};
export var getPauseReasonLabel = function (reasonCode) { var _a; return (_a = PAUSE_REASON_LABELS[reasonCode]) !== null && _a !== void 0 ? _a : reasonCode; };
